import React from "react";
import PageTitle from "../../../Components/PageTitle/PageTitle"; 
import { Col, Row } from "antd";
import { FiArrowUpRight } from "react-icons/fi";
import PharmaSosHyderabadSpeakers from "./PharmaSosHyderabadSpeakers"; 
import AssetPath from "../../../AssetPath/AssetPath";
import AgendaList from "../../Agenda/AgendaList";

export default function PharmasosConferenceHyderabad() {
  return (
    <>
      <PageTitle
        mainTitle="Pharma-SOS Conference"
        mainDesc="Join us at Pharma-SOS Conference in Hyderabad for exclusive insights and networking opportunities."
        date="October 13-14, 2025"
        location="Park Hyatt, Hyderabad"
        breadcrumbItems={[
          {
            name: "Pharma-SOS Conference",
            path: "/agenda",
          },
        ]}
        image={AssetPath.breadcrumb.annualConferenceHyderabad}
        strokeType="green"
      />
      <AgendaList title="Pharma-SOS Conference" />
 
      <PharmaSosHyderabadSpeakers />

    </>
  );
}
